import React from 'react';

import AuthenticationStore from '~/auth/authenticationStore';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Logo } from '~/eds/src/components/Logo/Logo';
import { Text } from '~/eds/src/components/Text/Text';
import { useIntl } from 'react-intl';

const AS = AuthenticationStore();

function Page() {
  const intl = useIntl();
  const isLoggedIn = AS.isLoggedIn();

  return (
    <Layout
      as="header"
      direction="column"
      spacing={16}
      pt={isLoggedIn ? 16 : 0}
    >
      {isLoggedIn ? null : (
        <Layout
          align="center"
          bg="inverse.background"
          h="header.height"
          justify="space-between"
          px="6"
        >
          <a href="/" title="Evisort login page">
            <Logo theme="dark" />
          </a>
        </Layout>
      )}
      <Layout align="center" direction="column">
        <Text as="h1" variant="subtitle">
          {intl.formatMessage({
            id: 'EmailActionRejectSucceedsPage.ticketRejected',
            defaultMessage: 'Ticket rejected',
            description: 'Message when ticket is rejected',
          })}
        </Text>
      </Layout>
    </Layout>
  );
}

export default Page;
